import { useCallback, useState } from 'react';
import { getNextListViewSort } from 'helpers/listViewSortHelpers';
import { ListViewSortDirection } from 'types/listViewColumns';

const useListViewSortState = <TSortField extends string>(
  initialField: TSortField,
  initialDirection: ListViewSortDirection = 'DESC',
) => {
  const [sortField, setSortField] = useState(initialField);
  const [sortDirection, setSortDirection] =
    useState<ListViewSortDirection>(initialDirection);

  const onSort = useCallback(
    (field: TSortField) => {
      const next = getNextListViewSort(sortField, sortDirection, field);
      setSortField(next.field);
      setSortDirection(next.direction);
    },
    [sortDirection, sortField],
  );

  return { sortField, sortDirection, onSort, setSortField, setSortDirection };
};

export { useListViewSortState };
